import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
import * as util from "../../utill";
/** Components Import */
import Terms from "./Terms";
import { Navbar, Container, Badge, Button, Alert, Form, Card, Stack } from "react-bootstrap";
import { Loading, Dropdown, Checkbox } from "../../Components/Bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
/** Styles Import */
import "./Style.css";
/** Images Import */
import Logo from "../../Assets/Images/busanbus_logo.png";
/** Icons Import */
import { faDownload, faArrowUpFromBracket, faArrowRight, faRotateRight, faXmark } from "@fortawesome/free-solid-svg-icons";
/** FCM Import */
import { initializeApp } from "firebase/app";
import { getToken, getMessaging, onMessage, isSupported } from "firebase/messaging";

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const bookmarkStates = useSelector((state) => state.Bookmarks);
  const [inputs, setInputs] = useState({
    termsChecked: Commons.Storages("get", "saves").termsAgree, // Info_Yn
    busNo: Commons.Storages("get", "saves").busNo,
    signInToggle: false,
    companySelected: Commons.Storages("get", "saves").saves ? Commons.Storages("get", "saves").company : "",
    id: Commons.Storages("get", "saves").saves ? Commons.Storages("get", "saves").userId : "",
    password: Commons.Storages("get", "saves").saves ? Commons.Storages("get", "saves").password : "",
    saveChecked: Commons.Storages("get", "saves").saves ? Commons.Storages("get", "saves").saves : false,
    alertShow: false,
  });
  const { termsChecked, busNo, signInToggle, companySelected, id, password, saveChecked, alertShow } = inputs;
  const [companyList, setCompanyList] = useState([]);
  const autoDispatchList = useRef([]);
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isPC, setIsPC] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  /** Firebase Config Variant */
  let firebaseSupported = false;
  let firebaseMessaging = null;
  let firebaseToken = "0";
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };
  const firebase = initializeApp(firebaseConfig);
  isSupported().then((result) => {
    firebaseSupported = result;
    if (result) {
      firebaseMessaging = getMessaging(firebase);
      util.getPermission();
      onMessage(firebaseMessaging, (payload) => {
        // console.log("Message received. ", payload);
        Commons.Toast("info", () => (
          <div>
            {`[ ${payload.notification.title} ]`}
            <br />
            {payload.notification.body}
          </div>
        ));
      });
    }
  });

  useEffect(() => {
    // 플랫폼 감지
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    setIsAndroid(/android/i.test(userAgent));
    setIsIOS(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
    setIsPC(!/android|iPad|iPhone|iPod/i.test(userAgent));

    // PWA 설치 이벤트 감지 (Android)
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    });
    Init();
    return () => {
      window.removeEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
      });
    };
  }, []);

  const Init = async () => {
    try {
      await SelectLogic(); // 운수사 데이터 조회
      await SelectLogic1(); // 즐겨찾기 버스 배차 조회
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 운수사 데이터 조회
  const SelectLogic = async () => {
    setLoading(true);

    try {
      await Commons.Axios("getOther", Global.base.useUrl + Global.urls.PublicDispatch.DdlCode, {
        code: "company",
        key1: "",
        key2: "",
        key3: "",
        key4: "",
      }).then((result) => {
        let data = result.data;
        console.log("운수사 데이터 조회: ", data);

        if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          setCompanyList(data);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 즐겨찾기 버스 배차 조회
  const SelectLogic1 = async () => {
    setLoading(true);
    let _routeId = null;

    try {
      if (bookmarkStates.bookmarks) {
        _routeId = bookmarkStates.routeId;
        setInputs({ ...inputs, busNo: bookmarkStates.busNo });
      } else {
        _routeId = Commons.Storages("get", "saves").routeId;
        setInputs({ ...inputs, busNo: Commons.Storages("get", "saves").busNo });
      }

      if (_routeId) {
        await Commons.Axios("getOther", Global.base.useUrl + Global.urls.PublicDispatch.PublicDispatch, { routeId: _routeId }).then((result) => {
          let data = result.data;
          // console.log("즐겨찾기 버스 배차 조회: ", data);

          if (data === "데이터가 없습니다.") {
            // throw new Error(data);
          } else if (data.length > 0) {
            autoDispatchList.current = data;
          }
        });
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // InApp 설치 이벤트
  const HandleInstallClick = () => {
    if (isAndroid || isPC) {
      if (deferredPrompt) {
        // Android 및 PC: PWA 설치
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            // console.log("PWA 설치 완료");
          } else {
            // console.log("PWA 설치 취소");
          }
          setDeferredPrompt(null);
        });
      } else {
        Commons.Toast("info", "이 브라우저는 PWA 설치를 지원하지 않습니다.");
      }
    } else if (isIOS) {
      // iOS: Safari "홈 화면에 추가" 안내
      toast(
        () => (
          <React.Fragment>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "24px",
                marginRight: "24px",
                marginBottom: "16px",
              }}
            >
              <FontAwesomeIcon color='#FFD700' size='3x' icon={faArrowUpFromBracket} />
              <FontAwesomeIcon size='2x' icon={faArrowRight} />
              <span style={{ color: "#FFD700", fontSize: "20px" }}>홈 화면에 추가</span>
            </div>
            <div className='divider' />
            <div>
              <span>URL 주소창 옆의 </span>
              <FontAwesomeIcon color='#FFD700' icon={faArrowUpFromBracket} />
              <span> 모양 아이콘을 클릭 후 </span>
            </div>
            <div style={{ marginBottom: "24px" }}>
              <span style={{ color: "#FFD700" }}>'홈 화면에 추가'</span>
              <span>를 선택하세요.</span>
            </div>
          </React.Fragment>
        ),
        {
          position: "bottom-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        }
      );
    } else {
      Commons.Toast("info", "이 플랫폼에서는 설치가 지원되지 않습니다.");
    }
  };

  const RetryGetDeviceToken = async (retries) => {
    try {
      return await getToken(firebaseMessaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      });
    } catch (error) {
      if (retries === 0) {
        console.error("최대 재시도 횟수 초과:", error);
        throw error;
      } else {
        console.warn(`getDeviceToken 재시도 중... 남은 횟수: ${retries}`);
        return RetryGetDeviceToken(retries - 1);
      }
    }
  };

  const LoginLogic = async (e) => {
    e.preventDefault();
    setLoading(true);
    let userInfo = [];
    let menuList = [];

    try {
      if (!saveChecked && !companySelected) {
        return setInputs({
          ...inputs,
          show: true,
        });
      }
      if (saveChecked) {
        Commons.Storages("set", "saves", {
          ...Commons.Storages("get", "saves"),
          company: companySelected,
          userId: id,
          saves: saveChecked,
        });
      }
      // if (!Commons.Storages("get", "saves").termsAgree) {
      //   Commons.Storages("set", "saves", {
      //     ...Commons.Storages("get", "saves"),
      //     termsAgree: true,
      //   });
      // }
      if (firebaseSupported) {
        if (Notification.permission !== "granted" || !Commons.IsMobile()) {
          firebaseToken = "WEB"; // denied alarm
        } else {
          // firebaseToken = await getToken(firebaseMessaging, {
          //   vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
          // });
          firebaseToken = await RetryGetDeviceToken(3);
        }
      } else {
        firebaseToken = "WEB";
      }

      // Commons.Storages("set", "fcmServices", {
      //   ...Commons.Storages("get", "fcmServices"),
      //   token: firebaseToken,
      //   date: Commons.DateFormating(new Date(), 2),
      //   time: Commons.DateFormating(new Date(), 7),
      // });

      await IndexedDb.ClearDb("AuthList");
      await IndexedDb.ClearDb("LoginInfo");
      await IndexedDb.ClearDb("MenuList");

      await Commons.Axios("login", Global.base.useUrl + Global.urls.login, {
        companyId: companySelected,
        userId: id,
        password: password,
        fcmToken: firebaseToken,
      }).then(async (result) => {
        let data = result.data;
        console.log("LoginLogic: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data.userInfo.token) {
          userInfo.push(data.userInfo);
          if (data.menuList.length > 0) {
            for (let i = 0; i < data.menuList.length; i++) {
              menuList.push(data.menuList[i]);
            }
          }
        }

        await IndexedDb.AddDb("LoginInfo", userInfo);
        await IndexedDb.AddDb("MenuList", menuList);

        if (data.userInfo.authorityId == "1") {
          navigate("/AutoDispatch");
        } else if (data.userInfo.authorityId == "2") {
          navigate("/ChangeCar");
        } else if (data.userInfo.authorityId == "7") {
          navigate("/AdminAutoDispatch");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      // Commons.Toast("error", `Error: ${e.message}`);
      Commons.Toast("error", `아이디 혹은 비밀번호를 확인하세요.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-wrap'>
      <Navbar className='header-navbar-wrap mb-3'>
        <Container>
          <Navbar.Brand style={{ display: "flex", alignItems: "center" }}>
            <img width={30} height={30} src={Logo} />
            <div style={{ marginLeft: "8px" }}>운행관리 표준화 시스템</div>
          </Navbar.Brand>
          <FontAwesomeIcon size='lg' color='#0d6efd' icon={faDownload} onClick={HandleInstallClick} />
        </Container>
      </Navbar>
      <Container className='login-bus-info___container'>
        <div className='login-bus-info___head mb-2'>
          {/* {!Commons.Storages("get", "saves").termsAgree ? (
            <Checkbox className='terms-checkbox' title='개인정보 수집 &#183; 이용에 동의합니다.' value={termsChecked} onChange={(e) => setInputs({ ...inputs, termsChecked: e })} />
          ) : ( */}
          <Badge className='login-custom-badge' bg='dark'>
            {busNo ? busNo : "0"}
          </Badge>
          {/* )} */}
          <div>
            {/* {!Commons.Storages("get", "saves").termsAgree ? null : (
              <Button className='mx-3' onClick={() => SelectLogic1()}>
                <FontAwesomeIcon icon={faRotateRight} />
              </Button>
            )} */}
            <Button
              // disabled={!termsChecked}
              onClick={() => setInputs({ ...inputs, signInToggle: true })}
            >
              로그인
            </Button>
          </div>
        </div>
        {/* {!Commons.Storages("get", "saves").termsAgree ? (
          <Terms />
        ) : ( */}
        <Card>
          <Card.Body className='login-grid-header'>
            <Stack direction='horizontal'>
              <div className='p-2 login-grid-header-text login-text-width-48'>회차</div>
              <div className='p-2 login-grid-header-text login-text-width-80'>출발시간</div>
              <div className='p-2 login-grid-header-text login-text-width-80'>차량번호</div>
              <div className='p-2 login-grid-header-text login-text-width-64'>승무원</div>
              <div className='p-2 login-grid-header-text login-text-width-48'>비고</div>
            </Stack>
          </Card.Body>
        </Card>
        <div className='login-grid-datas'>
          {autoDispatchList.current.map((item, index) => {
            const CheckNumberCar = () => {
              if (index == 0) {
                return "custom-table-grid-datas-first";
              } else if (index == 1 || index == 2) {
                return "custom-table-grid-datas-next";
              } else {
                return "";
              }
            };

            // const UserCheckColor = () => {
            //   if (
            //     item.driverId === Commons.Storages("get", "saves").userId
            //   ) {
            //     return "#ffffff";
            //   } else {
            //     return "#000000";
            //   }
            // };
            // const UserCheckBgColor = () => {
            //   if (
            //     item.driverId === Commons.Storages("get", "saves").userId
            //   ) {
            //     return "#0052cc";
            //   } else {
            //     return "#ffffff";
            //   }
            // };

            return (
              <Card key={index}>
                <Card.Body className={`login-grid-body ${CheckNumberCar()}`}>
                  <Stack direction='horizontal'>
                    <div className='p-2 login-grid-body-text login-text-width-48'>{item.opratIdx}</div>
                    <div className='p-2 login-grid-body-text login-text-width-80'>{item.caralcDtm}</div>
                    <div className='p-2 login-grid-body-text login-text-width-80'>{item.vhcleNo}</div>
                    <div className='p-2 login-grid-body-text login-text-width-64'>{item.name}</div>
                    <div className='p-2 login-grid-body-text login-text-width-48'>{item.remark}</div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
        {/* )} */}
      </Container>
      {signInToggle && (
        <div
          style={{
            position: "absolute",
            top: "150px",
          }}
        >
          <div className='sign-in__wrapper'>
            <Form className='shadow p-4 bg-white rounded' onSubmit={LoginLogic}>
              <Button
                variant='light'
                onClick={() =>
                  setInputs({
                    ...inputs,
                    companySelected: Commons.Storages("get", "saves").saves ? Commons.Storages("get", "saves").company : "",
                    id: Commons.Storages("get", "saves").saves ? Commons.Storages("get", "saves").userId : "",
                    password: "",
                    saveChecked: Commons.Storages("get", "saves").saves ? Commons.Storages("get", "saves").saves : false,
                    signInToggle: false,
                  })
                }
              >
                <FontAwesomeIcon size='xl' icon={faXmark} />
              </Button>
              <img className='img-thumbnail mx-auto d-block mb-2' src={Logo} alt='logo' />
              <div className='h4 mb-2 text-center'>Sign In</div>
              {alertShow ? (
                <Alert className='mb-2' variant='danger' onClose={() => setInputs({ ...inputs, alertShow: false })} dismissible>
                  입력 값을 확인하세요.
                </Alert>
              ) : (
                <div />
              )}
              <Form.Group className='mb-2'>
                <Form.Label>운수사</Form.Label>
                <Dropdown
                  variant='outline-primary'
                  // title="운수사를 고르세요."
                  title={companyList.length && companyList.length > 0 && companySelected ? companyList.filter((f) => f.value == companySelected)[0].text : "운수사를 고르세요."}
                  items={companyList}
                  value={companySelected}
                  onChange={(e) => setInputs({ ...inputs, companySelected: e })}
                />
              </Form.Group>
              <Form.Group className='mb-2' controlId='username'>
                <Form.Label>ID(사번)</Form.Label>
                <Form.Control type='text' value={id} onChange={(e) => setInputs({ ...inputs, id: e.target.value })} required />
              </Form.Group>
              <Form.Group className='mb-2' controlId='password'>
                <Form.Label>Password</Form.Label>
                <Form.Control type='password' value={password} onChange={(e) => setInputs({ ...inputs, password: e.target.value })} required />
              </Form.Group>
              <Form.Group className='mb-4' controlId='checkbox'>
                <Form.Check
                  type='checkbox'
                  label='아이디 저장'
                  value={saveChecked}
                  checked={saveChecked}
                  onChange={(e) => {
                    setInputs({ ...inputs, saveChecked: e.target.checked });
                    Commons.Storages("set", "saves", {
                      ...Commons.Storages("get", "saves"),
                      company: companySelected,
                      userId: id,
                      password: password,
                      saves: e.target.checked,
                    });
                  }}
                />
              </Form.Group>
              <Button className='w-100' variant='primary' type='submit'>
                Log In
              </Button>
              <div
                className='version'
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "gray",
                  marginTop: "14px",
                }}
              >
                <a>{Commons.Storages("get", "version").version}</a>
              </div>
            </Form>
          </div>
        </div>
      )}
      <Loading show={loading} />
    </div>
  );
};

export default Login;
